// Cores originais do projeto
export const GREE_1 = '#275c53';
export const GREE_3 = '#1B7573';
export const GREE_2 = '#f7fbfd';
export const GRAY_1 = 'rgba(0, 0, 0, 0.1)';
export const GRAY_2 = '#F4F9FC';
export const GRAY_3 = '#333';


// Paleta inspirada no Plantei.com.br
export const PLANTEI_DARK = '#232323';
export const PLANTEI_ORANGE = '#ff7734';
export const PLANTEI_GREEN = '#01a750';
export const PLANTEI_BLUE = '#277bf9';
export const PLANTEI_PURPLE = '#c330a1';
export const PLANTEI_LIGHT_BLUE = '#3483fa';
export const WHITE = '#ffffff';
export const LIGHT_GRAY = '#f5f5f5';
export const BORDER_GRAY = '#e0e0e0';

export const ORDER_STATUS_COLOR = {
    PENDING_PAYMENT: 'orange',
    PAID: 'blue',
    PREPARING: 'cyan',
    SHIPPED: 'geekblue',
    DELIVERED: 'green',
    CANCELLED: 'red',
};

export const PRESCRIPTION_STATUS_COLOR = {
    PENDING: 'orange',
    VALIDATED: 'green',
    EXPIRED: 'gray',
    INVALIDATED: 'red',
};

export const REPORT_STATUS_COLOR = {
    processing: 'blue',
    done: 'green',
    error: 'red',
};

export const AUDIT_ACTION_COLOR = {
    CREATE: 'green',
    UPDATE: 'blue',
    DELETE: 'red',
};